export function DatePicker({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <input
      type="date"
      value={(value as string) ?? ''}
      onChange={e => onChange(e.target.value)}
      className="border rounded px-2 py-1 text-sm flex-1"
    />
  )
}
